module.exports = __webpack_public_path__ + "static/media/canhemon_small@2x.d8c79a1c.jpg";